module.exports = __webpack_public_path__ + "static/media/level3-off.aa8a2fbd.svg";